<div class="spinner-container" [style.width.px]="size" [style.height.px]="size">
  <div class="spinner-circle">
    <div>
      <span class="visually-hidden">{{ 'loading_spinner_text' | translate }}</span>
    </div>
  </div>
</div>
